import { Component, Inject, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { VehicleManagementComponent } from '../vehicle-management.component';

export interface DialogData {
  licensePlate: string;
}

@Component({
  selector: 'app-edit-license-plate',
  templateUrl: './edit-license-plate.component.html',
  styleUrls: ['./edit-license-plate.component.scss']
})
export class EditLicensePlateComponent implements OnInit {

  constructor(public dialogRef: MatDialogRef<VehicleManagementComponent>,
    @Inject(MAT_DIALOG_DATA) public data: DialogData,) { }

  ngOnInit(): void {
  }

  // updateSwitchValues(val: boolean) {
  //   this.data.status = val;
  // }

  onNoClick(): void {
    this.dialogRef.close();
  }

}
